import 'url-search-params-polyfill';
import addPolyfills from './polyfills';
import DeviceManager from './utils/device-manager';
import Footer from './components/footer';
import Cmi from './components/btn-cmi';
import FaqList from './components/faq-list';
import Forms from './components/forms';
import DynamicMap from './components/dynamic-map';
import BlogListSelect from './components/blog-list-select';
import Header from './components/header';
import SimilarPosts from './components/similar-posts';
import HomepagePush from './components/homepage-push';
import ServiceCarousel from './components/services-carousel';
import TestimonialsCarousel from './components/testimonials-carousel';
import TestimonialsSwiper from './components/testimonials-swiper';
import TabsList from "./components/tabs-list";
import RelevantContent from './components/relevant-content';
import VerticalTimeline from './components/vertical-timeline';
import ProfessionalTypes from './components/professional-types';
import Popover from './components/popover';
import FloatingCards from './components/floating-cards';
import SwiperMobile from './components/swiper-on-mobile';
import PartenairePro from './components/partenaire-pro';
import { BrowserChecker, getBrowserInfos } from './utils/browser-checker';
import Contact from './components/contact';
import FormNews from './components/form-news';
import VimeoPopup from './components/vimeo-popup';
import TimelineCarousel from './components/timeline-carousel';
import CarouselOffers from "./components/carousel-offers";
import PrivatePage from "./components/private-page";
import LogoAlternatif from "./utils/logo-alternatif";


addPolyfills();
if (getBrowserInfos().name === 'IE') {
    document.body.classList.add('ie');
}

if (BrowserChecker.isSafari()) {
    document.body.classList.add('safari');
}

if (getBrowserInfos().name === "Edge") {
    document.body.classList.add('edge');
}

if (typeof google_api_key !== 'undefined') {
    const $mapsContainers = document.querySelectorAll('.js-dynamic-map');

    if ($mapsContainers.length > 0) {
        // Create  and inject script for maps
        const $mapsScript = document.createElement('script');
        $mapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${google_api_key}&callback=initMap&libraries=places`;
        $mapsScript.defer = true;
        document.head.appendChild($mapsScript);

        // Initialize JS when the script previously injected is ready
        window.initMap = () => {
            $mapsContainers.forEach($mapContainer => {
                new DynamicMap($mapContainer);
            });
        }
    }
}

const $allFloatingCards = document.querySelectorAll('.js-floating-cards');
$allFloatingCards.forEach($floatingCards => {
    new FloatingCards($floatingCards);
});

TabsList.init();
Header.init();
Footer.init();
BlogListSelect.init();
Forms.init();
FaqList.init();
SimilarPosts.init();
HomepagePush.init();
ServiceCarousel.init();
TestimonialsCarousel.init();
TestimonialsSwiper.init();
RelevantContent.init();
VerticalTimeline.init();
ProfessionalTypes.init();
Popover.init();
SwiperMobile.init();
Cmi.init();
PartenairePro.init();
Contact.init();
FormNews.init();
VimeoPopup.init();
TimelineCarousel.init();
CarouselOffers.init();
PrivatePage.init();
LogoAlternatif.init();


// Always call after all other files
DeviceManager.init();